import { Navigate, Route, Routes } from 'react-router';

import { STEPS, basePath, getStepPath, getStepPathWithCarParam } from '../../../utils/navigation';
import { CarContract, Overview, ThankYou, UserInformationV2 } from '../steps';

export const useRequestFlowRoutes = (
	setIsAppHealthy: (isHealthy: boolean) => void,
	setThankYouError: (error: boolean) => void
) => (
	<Routes>
		<Route
			path={basePath}
			element={<Navigate to={getStepPathWithCarParam(STEPS.CAR_CONTRACT)} replace />}
		/>
		<Route path={getStepPath(STEPS.CAR_CONTRACT)} element={<CarContract />} />
		<Route path={getStepPath(STEPS.USER_INFORMATION)} element={<UserInformationV2 />} />
		<Route
			path={getStepPath(STEPS.OVERVIEW)}
			element={<Overview onAppHealthChange={setIsAppHealthy} />}
		/>
		<Route
			path={getStepPath(STEPS.THANK_YOU)}
			element={<ThankYou onErrorChange={setThankYouError} />}
		/>
	</Routes>
);
